import * as React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import cn from 'classnames';

type Param = {
  name: string;
  value: string | number | undefined;
  className?: string;
};

type ParamGroup = {
  title: string;
  items: Param[];
};

type Props = {
  params: ParamGroup[];
};

export const Params: React.FC<Props> = ({ params }) => (
  <Stack direction="row" gap={2}>
    {params.map((group) => (
      <Box key={group.title} flex={1}>
        <Typography variant="subtitle2" gutterBottom>
          {group.title}
        </Typography>
        <Stack spacing={1}>
          {group.items.map((param, index) => (
            <Box key={index} display="flex" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">
                {param.name}:
              </Typography>
              <Typography variant="body2" className={cn(param.className)} textAlign="right">
                {param.value ?? '—'}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    ))}
  </Stack>
);
